import {
  ACCORDIONIDS_TO_VALIDATION_FUNCTION_MAPPING,
  TEST_SUITE_TYPES,
} from "../constants";
import { createTestSuiteResponseObject } from "../HelperFunctions";

export class FileTest {
  constructor(dataset, accordionDatasetId) {
    this.accordionDatasetId = accordionDatasetId;
    this.intraValidationTestSuite =
      ACCORDIONIDS_TO_VALIDATION_FUNCTION_MAPPING[
        accordionDatasetId
      ].scripts.intraValidationTestSuite;
    this.interValidationSuite =
      ACCORDIONIDS_TO_VALIDATION_FUNCTION_MAPPING[
        accordionDatasetId
      ].scripts.interValidationSuite;
    this.schemaValidationTestSuite =
      ACCORDIONIDS_TO_VALIDATION_FUNCTION_MAPPING[
        accordionDatasetId
      ].scripts.schemaValidationTestSuite;
    this.dataset = dataset;
  }

  getCustomTestSuiteResults(validationResult, testSuiteType) {
    for (let unitTestName in validationResult) {
      const checkedUnitTestStatus = validationResult[unitTestName].passed;
      if (checkedUnitTestStatus === false) {
        const testSuiteResponseObject = createTestSuiteResponseObject(
          testSuiteType,
          unitTestName,
          checkedUnitTestStatus
        );
        return {
          testSuiteResult: testSuiteResponseObject,
          failedUnitTest: validationResult[unitTestName],
        };
      }
    }
    return {
      testSuiteResult: createTestSuiteResponseObject(testSuiteType, null, true),
    };
  }

  runSchemaValidationTestSuite() {
    const schemaValidationUnitTestsResults = this.schemaValidationTestSuite(
      this.dataset
    );
    const schemaValidationTestSuiteResults = this.getCustomTestSuiteResults(
      schemaValidationUnitTestsResults,
      TEST_SUITE_TYPES.schema
    );

    return schemaValidationTestSuiteResults;
  }

  runIntraValidationCustomTestSuite() {
    const intraValidationUnitTestsResults = this.intraValidationTestSuite(
      this.dataset
    );
    const intraValidationTestSuiteResults = this.getCustomTestSuiteResults(
      intraValidationUnitTestsResults,
      TEST_SUITE_TYPES.intraValidation
    );

    return intraValidationTestSuiteResults;
  }

  runFileTest() {
    if (this.schemaValidationTestSuite !== null) {
      const schemaValidationTestSuiteResults =
        this.runSchemaValidationTestSuite();
      if (
        schemaValidationTestSuiteResults.testSuiteResult.testSuiteIsPassed ===
        false
      )
        return {
          testSuiteResults: schemaValidationTestSuiteResults,
          status: "Fail",
        };
    }

    if (this.intraValidationTestSuite !== null) {
      const intraValidationTestSuiteResults =
        this.runIntraValidationCustomTestSuite();
      if (
        intraValidationTestSuiteResults.testSuiteResult.testSuiteIsPassed ===
        false
      )
        return {
          testSuiteResults: intraValidationTestSuiteResults,
          status: "Fail",
        };
    }

    return { status: "Success" };
  }
}
